export enum Messages {
    LINK_CREATE_SUCCESS = 'Link shortened',
    LINK_UPDATE_SUCCESS = 'Link updated',
    LINK_DELETE_SUCCESS = 'Links deleted',
    MULTIPLE_LINKS_CREATE_SUCCESS = 'Multiple links created',
    LINK_ATTACH_SUCCESS = 'Link attached',
    QR_COPY_SUCCESS = 'QR code copied',
    LINK_COPY_SUCCESS = 'Copied link to clipboard',
    LINK_GROUP_DELETE_SUCCESS = 'Link group deleted',
    WORKSPACE_INVITE_DECLINED = 'workspace invitation declined',
    TRACKING_PIXEL_CREATE_SUCCESS = 'Tracking pixel created',
    TRACKING_PIXEL_UPDATE_SUCCESS = 'Tracking pixel updated',
    TRACKING_PIXEL_DELETE_SUCCESS = 'Tracking pixels deleted',
    LINK_OVERLAY_CREATE_SUCCESS = 'Link overlay created',
    LINK_OVERLAY_UPDATE_SUCCESS = 'Link overlay updated',
    LINK_OVERLAY_DELETE_SUCCESS = 'Link overlays deleted',
    LINK_SHORTEN_SUCCESS = 'Link shortened',
    LINK_SHORTEN_FAIL = 'Could not shorten link. Please try again later',
}
